import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import { locales } from '@/locales'

Vue.use(VeeValidate)

// App locale codes that differ from vee-validate's dictionary file names.
const DICTIONARY_LOCALE_MAP = {
	ee: 'et',
	cz: 'cs',
	se: 'sv'
}

const getCustomValidationMessage = (rule, locale) => {
	const raw = locales[locale]?.common?.validation?.[rule] || locales.en?.common?.validation?.[rule]

	return (field, params = []) => (raw || '')
		.replace(/{field}/g, () => field)
		.replace(/{length}/g, () => params[0])
}

export async function changeValidatorLocale (locale, attributes) {
	let localeDictonary
	try {
		localeDictonary = await import(`vee-validate/dist/locale/${DICTIONARY_LOCALE_MAP[locale] || locale}`)
	} catch (_e) {
		localeDictonary = await import('vee-validate/dist/locale/en')
	}

	Validator.localize(locale, {
		...localeDictonary.default,
		attributes
	})

	const messages = {}
	if (locales[locale]?.common?.validation?.digits) {
		messages.digits = getCustomValidationMessage('digits', locale)
	}

	Validator.localize(locale, { messages })
}


